import { never } from "@vendrinc/frontend-ts";
import { z } from "zod";
import { TypeOfPurchase } from "../privateOffers/answers";

export type ContractType = "NewPurchase" | "Renewal";

export enum ContractTypeParam {
  NewPurchase = "newPurchase",
  Renewal = "renewal",
}

export const ContractTypeParamSchema = z.union([
  z.nativeEnum(ContractTypeParam),
  z.null(),
]);

export const toContractType = (value: ContractTypeParam) => {
  switch (value) {
    case ContractTypeParam.NewPurchase:
      return "NewPurchase";

    case ContractTypeParam.Renewal:
      return "Renewal";

    default:
      return never(value);
  }
};

export const contractTypeToTypeOfPurchase = (
  contractType: ContractType,
): TypeOfPurchase => {
  switch (contractType) {
    case "NewPurchase":
      return TypeOfPurchase.NewPurchase;
    case "Renewal":
      return TypeOfPurchase.Renewal;
    default:
      return never(contractType);
  }
};
